/**
 * @file Apollo GrapqhQL helper
 */
import { fetchResponse } from '@padlet/fetch'
import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory'
import ApolloClient from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import getCsrfToken from 'bits/csrf_token'
import { ww } from 'bits/global'
import VueApollo from 'vue-apollo'

const apolloClient: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: '/api/graphql',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'X-UID': ww?.uid,
    },
    fetch: fetchResponse,
  }),
})

// Backward compatibility
const apolloProvider: VueApollo = new VueApollo({
  defaultClient: apolloClient,
})

export { apolloClient, apolloProvider }
